<template>
  <DialogFull :data="dialogSettings" @close="close">
    <div class="container col-lg-8 col-sm-12">
      <LanguagesAndSkills @close="close" submitButtonTitle="Save Changes" />
    </div>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import LanguagesAndSkills from "@/views/profile/QuestionsAndAnswers/steps/LanguagesAndSkills/LanguagesAndSkills";

export default {
  name: "EditLanguagesAndSkillsDialog",
  components: {
    DialogFull,
    LanguagesAndSkills
  },
  props: {
    isOpen: Boolean
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Languages & Skills"
      };
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
